import React from 'react';
import InviteUser from '@jumbo/components/Common/authComponents/InviteUserTo';

const InviteUserToTmTeam = () => <InviteUser variant="standard" wrapperVariant="bgColor" />;

export default InviteUserToTmTeam;
